import{useContext}from'react';import CartItemProductContext from"./CartItemProductProvider.context";import CartItemContext from"./CartItemProvider.context";/**
 * Returns the value of the cart item product provider state.
 * @returns {Object}
 */export var useCartItemProduct=function useCartItemProduct(){return useContext(CartItemProductContext);};/**
 * Returns the value of the cart item provider state.
 * @returns {Object}
 */export var useCartItem=function useCartItem(){return useContext(CartItemContext);};